/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Admins.Api
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CancelVisitAdminApiInContract,
  CreateVisitAdminApiInContract,
  DeleteVisitMedicalRecordsAdminApiInContract,
  ErrorApiOutContract,
  ErrorDescription,
  GetVisitsParams,
  MessageApiContract,
  PatientVisitListItemStaffApiOutContract,
  RescheduleVisitAdminApiInContract,
  VisitAdminApiOutContract,
  VisitCollectionItemAdminApiOutContractPaginationItemCollectionApiOutContract
} from '../pwrdbyQuickMDAdminsApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Creates a new visit using the provided contract.
 */
export const postVisits = (
    createVisitAdminApiInContract: CreateVisitAdminApiInContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<ErrorDescription>(
      {url: `https://admins-api.api.quick.md/api/v1/visits`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createVisitAdminApiInContract, signal
    },
      options);
    }
  


export const getPostVisitsMutationOptions = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVisits>>, TError,{data: CreateVisitAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postVisits>>, TError,{data: CreateVisitAdminApiInContract}, TContext> => {

const mutationKey = ['postVisits'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postVisits>>, {data: CreateVisitAdminApiInContract}> = (props) => {
          const {data} = props ?? {};

          return  postVisits(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostVisitsMutationResult = NonNullable<Awaited<ReturnType<typeof postVisits>>>
    export type PostVisitsMutationBody = CreateVisitAdminApiInContract
    export type PostVisitsMutationError = ErrorDescription | void | ErrorApiOutContract

    /**
 * @summary Creates a new visit using the provided contract.
 */
export const usePostVisits = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVisits>>, TError,{data: CreateVisitAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postVisits>>,
        TError,
        {data: CreateVisitAdminApiInContract},
        TContext
      > => {

      const mutationOptions = getPostVisitsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getVisits = (
    params?: GetVisitsParams,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<VisitCollectionItemAdminApiOutContractPaginationItemCollectionApiOutContract>(
      {url: `https://admins-api.api.quick.md/api/v1/visits`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetVisitsInfiniteQueryKey = (params?: GetVisitsParams,) => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/visits`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetVisitsQueryKey = (params?: GetVisitsParams,) => {
    return [
    `https://admins-api.api.quick.md/api/v1/visits`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetVisitsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisits>>>, TError = void | ErrorApiOutContract>(params?: GetVisitsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisits>>> = ({ signal }) => getVisits(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisits>>>
export type GetVisitsInfiniteQueryError = void | ErrorApiOutContract


export function useGetVisitsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisits>>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetVisitsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisits>>,
          TError,
          Awaited<ReturnType<typeof getVisits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisits>>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisits>>,
          TError,
          Awaited<ReturnType<typeof getVisits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisits>>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVisitsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisits>>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetVisitsInfiniteQuery = async <TData = Awaited<ReturnType<typeof getVisits>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, params?: GetVisitsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsInfiniteQueryOptions(params,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsQueryOptions = <TData = Awaited<ReturnType<typeof getVisits>>, TError = void | ErrorApiOutContract>(params?: GetVisitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisits>>> = ({ signal }) => getVisits(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsQueryResult = NonNullable<Awaited<ReturnType<typeof getVisits>>>
export type GetVisitsQueryError = void | ErrorApiOutContract


export function useGetVisits<TData = Awaited<ReturnType<typeof getVisits>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetVisitsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisits>>,
          TError,
          Awaited<ReturnType<typeof getVisits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisits<TData = Awaited<ReturnType<typeof getVisits>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisits>>,
          TError,
          Awaited<ReturnType<typeof getVisits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisits<TData = Awaited<ReturnType<typeof getVisits>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVisits<TData = Awaited<ReturnType<typeof getVisits>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetVisitsQuery = async <TData = Awaited<ReturnType<typeof getVisits>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, params?: GetVisitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getVisits>>, TError = void | ErrorApiOutContract>(params?: GetVisitsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisits>>> = ({ signal }) => getVisits(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getVisits>>>
export type GetVisitsSuspenseQueryError = void | ErrorApiOutContract


export function useGetVisitsSuspense<TData = Awaited<ReturnType<typeof getVisits>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetVisitsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsSuspense<TData = Awaited<ReturnType<typeof getVisits>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsSuspense<TData = Awaited<ReturnType<typeof getVisits>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVisitsSuspense<TData = Awaited<ReturnType<typeof getVisits>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetVisitsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisits>>>, TError = void | ErrorApiOutContract>(params?: GetVisitsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisits>>> = ({ signal }) => getVisits(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisits>>>
export type GetVisitsSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetVisitsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisits>>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetVisitsParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisits>>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisits>>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVisitsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisits>>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsSuspenseInfiniteQueryOptions(params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getVisitsVisitId = (
    visitId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<VisitAdminApiOutContract>(
      {url: `https://admins-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetVisitsVisitIdInfiniteQueryKey = (visitId?: string,) => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/visits/${visitId}`
    ] as const;
    }

export const getGetVisitsVisitIdQueryKey = (visitId?: string,) => {
    return [
    `https://admins-api.api.quick.md/api/v1/visits/${visitId}`
    ] as const;
    }

    
export const getGetVisitsVisitIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitId>>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdInfiniteQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitId>>> = ({ signal }) => getVisitsVisitId(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(visitId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitId>>>
export type GetVisitsVisitIdInfiniteQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitId>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitId>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitId>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitId>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitId>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVisitsVisitIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitId>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdInfiniteQueryOptions(visitId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetVisitsVisitIdInfiniteQuery = async <TData = Awaited<ReturnType<typeof getVisitsVisitId>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsVisitIdInfiniteQueryOptions(visitId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsVisitIdQueryOptions = <TData = Awaited<ReturnType<typeof getVisitsVisitId>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitId>>> = ({ signal }) => getVisitsVisitId(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(visitId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitId>>>
export type GetVisitsVisitIdQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitId<TData = Awaited<ReturnType<typeof getVisitsVisitId>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitId>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitId<TData = Awaited<ReturnType<typeof getVisitsVisitId>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitId>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitId<TData = Awaited<ReturnType<typeof getVisitsVisitId>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVisitsVisitId<TData = Awaited<ReturnType<typeof getVisitsVisitId>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdQueryOptions(visitId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetVisitsVisitIdQuery = async <TData = Awaited<ReturnType<typeof getVisitsVisitId>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsVisitIdQueryOptions(visitId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsVisitIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getVisitsVisitId>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitId>>> = ({ signal }) => getVisitsVisitId(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitId>>>
export type GetVisitsVisitIdSuspenseQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitId>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitId>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitId>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVisitsVisitIdSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitId>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdSuspenseQueryOptions(visitId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetVisitsVisitIdSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitId>>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdInfiniteQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitId>>> = ({ signal }) => getVisitsVisitId(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitId>>>
export type GetVisitsVisitIdSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitId>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitId>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitId>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVisitsVisitIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitId>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdSuspenseInfiniteQueryOptions(visitId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const putVisitsVisitIdResolve = (
    visitId: string,
    messageApiContract: MessageApiContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/resolve`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: messageApiContract
    },
      options);
    }
  


export const getPutVisitsVisitIdResolveMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdResolve>>, TError,{visitId: string;data: MessageApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdResolve>>, TError,{visitId: string;data: MessageApiContract}, TContext> => {

const mutationKey = ['putVisitsVisitIdResolve'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putVisitsVisitIdResolve>>, {visitId: string;data: MessageApiContract}> = (props) => {
          const {visitId,data} = props ?? {};

          return  putVisitsVisitIdResolve(visitId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutVisitsVisitIdResolveMutationResult = NonNullable<Awaited<ReturnType<typeof putVisitsVisitIdResolve>>>
    export type PutVisitsVisitIdResolveMutationBody = MessageApiContract
    export type PutVisitsVisitIdResolveMutationError = void | ErrorApiOutContract

    export const usePutVisitsVisitIdResolve = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdResolve>>, TError,{visitId: string;data: MessageApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putVisitsVisitIdResolve>>,
        TError,
        {visitId: string;data: MessageApiContract},
        TContext
      > => {

      const mutationOptions = getPutVisitsVisitIdResolveMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Cancels a visit on the patient's behalf. A cancellation reason is required.
 */
export const deleteVisitsVisitIdCancel = (
    visitId: string,
    cancelVisitAdminApiInContract: CancelVisitAdminApiInContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<ErrorDescription>(
      {url: `https://admins-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/cancel`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: cancelVisitAdminApiInContract
    },
      options);
    }
  


export const getDeleteVisitsVisitIdCancelMutationOptions = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVisitsVisitIdCancel>>, TError,{visitId: string;data: CancelVisitAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteVisitsVisitIdCancel>>, TError,{visitId: string;data: CancelVisitAdminApiInContract}, TContext> => {

const mutationKey = ['deleteVisitsVisitIdCancel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVisitsVisitIdCancel>>, {visitId: string;data: CancelVisitAdminApiInContract}> = (props) => {
          const {visitId,data} = props ?? {};

          return  deleteVisitsVisitIdCancel(visitId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteVisitsVisitIdCancelMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVisitsVisitIdCancel>>>
    export type DeleteVisitsVisitIdCancelMutationBody = CancelVisitAdminApiInContract
    export type DeleteVisitsVisitIdCancelMutationError = ErrorDescription | void | ErrorApiOutContract

    /**
 * @summary Cancels a visit on the patient's behalf. A cancellation reason is required.
 */
export const useDeleteVisitsVisitIdCancel = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVisitsVisitIdCancel>>, TError,{visitId: string;data: CancelVisitAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteVisitsVisitIdCancel>>,
        TError,
        {visitId: string;data: CancelVisitAdminApiInContract},
        TContext
      > => {

      const mutationOptions = getDeleteVisitsVisitIdCancelMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * # Possible Errors
| HTTP status | ErrorCode                   | Description                                                                              |
|-------------|-----------------------------|------------------------------------------------------------------------------------------|
| 400         | DateTimeNotValid            | The requested date/time is not valid or not available.                                  |
| 400         | TimeZoneNotValid            | The requested time zone is not valid.                                                   |
| 400         | MethodNotValid              | Communication type is not valid.                                                        |
| 401         | Unauthorized                | Authentication is required to access this resource.                                     |
| 403         | VisitRescheduleNotAvailable | The visit is not in a reschedulable state, the provider is not verified, or the visit type is not available. |
| 404         | VisitNotFound               | Visit with the sent identifier is not found.                                            |
| 404         | ProviderNotFound            | Provider with the sent identifier is not found.                                         |
| 409         | TreatmentCenterNotAvailable | The provider has no availability at the visit's treatment center for the requested time. |
| 409         | BookingLockTimeout          | The provider's booking lock could not be acquired; the request can be retried.          |
| 500         | InternalServerError         | An unexpected error occurred on the server side.                                        |
 * @summary Reschedules a visit to a new time on the patient's behalf.
 */
export const putVisitsVisitIdReschedule = (
    visitId: string,
    rescheduleVisitAdminApiInContract: RescheduleVisitAdminApiInContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<unknown>(
      {url: `https://admins-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/reschedule`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rescheduleVisitAdminApiInContract
    },
      options);
    }
  


export const getPutVisitsVisitIdRescheduleMutationOptions = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdReschedule>>, TError,{visitId: string;data: RescheduleVisitAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdReschedule>>, TError,{visitId: string;data: RescheduleVisitAdminApiInContract}, TContext> => {

const mutationKey = ['putVisitsVisitIdReschedule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putVisitsVisitIdReschedule>>, {visitId: string;data: RescheduleVisitAdminApiInContract}> = (props) => {
          const {visitId,data} = props ?? {};

          return  putVisitsVisitIdReschedule(visitId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutVisitsVisitIdRescheduleMutationResult = NonNullable<Awaited<ReturnType<typeof putVisitsVisitIdReschedule>>>
    export type PutVisitsVisitIdRescheduleMutationBody = RescheduleVisitAdminApiInContract
    export type PutVisitsVisitIdRescheduleMutationError = ErrorDescription | void | ErrorApiOutContract

    /**
 * @summary Reschedules a visit to a new time on the patient's behalf.
 */
export const usePutVisitsVisitIdReschedule = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdReschedule>>, TError,{visitId: string;data: RescheduleVisitAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putVisitsVisitIdReschedule>>,
        TError,
        {visitId: string;data: RescheduleVisitAdminApiInContract},
        TContext
      > => {

      const mutationOptions = getPutVisitsVisitIdRescheduleMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getPatientsPatientIdVisitsPast = (
    patientId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<PatientVisitListItemStaffApiOutContract[]>(
      {url: `https://admins-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/visits/past`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPatientsPatientIdVisitsPastInfiniteQueryKey = (patientId?: string,) => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/patients/${patientId}/visits/past`
    ] as const;
    }

export const getGetPatientsPatientIdVisitsPastQueryKey = (patientId?: string,) => {
    return [
    `https://admins-api.api.quick.md/api/v1/patients/${patientId}/visits/past`
    ] as const;
    }

    
export const getGetPatientsPatientIdVisitsPastInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdVisitsPastInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>> = ({ signal }) => getPatientsPatientIdVisitsPast(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdVisitsPastInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>>
export type GetPatientsPatientIdVisitsPastInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdVisitsPastInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitsPastInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitsPastInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdVisitsPastInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdVisitsPastInfiniteQueryOptions(patientId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetPatientsPatientIdVisitsPastInfiniteQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdVisitsPastInfiniteQueryOptions(patientId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdVisitsPastQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdVisitsPastQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>> = ({ signal }) => getPatientsPatientIdVisitsPast(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdVisitsPastQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>>
export type GetPatientsPatientIdVisitsPastQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdVisitsPast<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitsPast<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitsPast<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdVisitsPast<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdVisitsPastQueryOptions(patientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetPatientsPatientIdVisitsPastQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdVisitsPastQueryOptions(patientId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdVisitsPastSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdVisitsPastQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>> = ({ signal }) => getPatientsPatientIdVisitsPast(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdVisitsPastSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>>
export type GetPatientsPatientIdVisitsPastSuspenseQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdVisitsPastSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitsPastSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitsPastSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdVisitsPastSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdVisitsPastSuspenseQueryOptions(patientId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPatientsPatientIdVisitsPastSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdVisitsPastInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>> = ({ signal }) => getPatientsPatientIdVisitsPast(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdVisitsPastSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>>
export type GetPatientsPatientIdVisitsPastSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdVisitsPastSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitsPastSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitsPastSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdVisitsPastSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdVisitsPastSuspenseInfiniteQueryOptions(patientId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getPatientsPatientIdVisitsUpcoming = (
    patientId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/visits/upcoming`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPatientsPatientIdVisitsUpcomingInfiniteQueryKey = (patientId?: string,) => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/patients/${patientId}/visits/upcoming`
    ] as const;
    }

export const getGetPatientsPatientIdVisitsUpcomingQueryKey = (patientId?: string,) => {
    return [
    `https://admins-api.api.quick.md/api/v1/patients/${patientId}/visits/upcoming`
    ] as const;
    }

    
export const getGetPatientsPatientIdVisitsUpcomingInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdVisitsUpcomingInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>> = ({ signal }) => getPatientsPatientIdVisitsUpcoming(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdVisitsUpcomingInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>>
export type GetPatientsPatientIdVisitsUpcomingInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdVisitsUpcomingInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitsUpcomingInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitsUpcomingInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdVisitsUpcomingInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdVisitsUpcomingInfiniteQueryOptions(patientId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetPatientsPatientIdVisitsUpcomingInfiniteQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdVisitsUpcomingInfiniteQueryOptions(patientId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdVisitsUpcomingQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdVisitsUpcomingQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>> = ({ signal }) => getPatientsPatientIdVisitsUpcoming(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdVisitsUpcomingQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>>
export type GetPatientsPatientIdVisitsUpcomingQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdVisitsUpcoming<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitsUpcoming<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitsUpcoming<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdVisitsUpcoming<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdVisitsUpcomingQueryOptions(patientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetPatientsPatientIdVisitsUpcomingQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdVisitsUpcomingQueryOptions(patientId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdVisitsUpcomingSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdVisitsUpcomingQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>> = ({ signal }) => getPatientsPatientIdVisitsUpcoming(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdVisitsUpcomingSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>>
export type GetPatientsPatientIdVisitsUpcomingSuspenseQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdVisitsUpcomingSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitsUpcomingSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitsUpcomingSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdVisitsUpcomingSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdVisitsUpcomingSuspenseQueryOptions(patientId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPatientsPatientIdVisitsUpcomingSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdVisitsUpcomingInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>> = ({ signal }) => getPatientsPatientIdVisitsUpcoming(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdVisitsUpcomingSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>>
export type GetPatientsPatientIdVisitsUpcomingSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdVisitsUpcomingSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitsUpcomingSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitsUpcomingSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdVisitsUpcomingSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdVisitsUpcomingSuspenseInfiniteQueryOptions(patientId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * # Possible Errors
| HTTP status | ErrorCode      | Description                                                        |
|-------------|----------------|--------------------------------------------------------------------|
| 400         | ReasonNotValid | A reason is required.                                              |
| 403         | Permission     | The admin lacks the visit.medicalrecords.delete permission.       |
| 404         | VisitNotFound  | Visit with the sent identifier is not found.                      |
| 404         | NoteNotFound   | The visit has no note with the sent identifier.                   |
 * @summary Deletes a single clinical note on a visit. Requires the `visit.medicalrecords.delete` permission. A reason is required and is recorded as a visit remark.
 */
export const deleteVisitsVisitIdNotesNoteId = (
    visitId: string,
    noteId: string,
    deleteVisitMedicalRecordsAdminApiInContract: DeleteVisitMedicalRecordsAdminApiInContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<unknown>(
      {url: `https://admins-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/notes/${encodeURIComponent(String(noteId))}`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteVisitMedicalRecordsAdminApiInContract
    },
      options);
    }
  


export const getDeleteVisitsVisitIdNotesNoteIdMutationOptions = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVisitsVisitIdNotesNoteId>>, TError,{visitId: string;noteId: string;data: DeleteVisitMedicalRecordsAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteVisitsVisitIdNotesNoteId>>, TError,{visitId: string;noteId: string;data: DeleteVisitMedicalRecordsAdminApiInContract}, TContext> => {

const mutationKey = ['deleteVisitsVisitIdNotesNoteId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVisitsVisitIdNotesNoteId>>, {visitId: string;noteId: string;data: DeleteVisitMedicalRecordsAdminApiInContract}> = (props) => {
          const {visitId,noteId,data} = props ?? {};

          return  deleteVisitsVisitIdNotesNoteId(visitId,noteId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteVisitsVisitIdNotesNoteIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVisitsVisitIdNotesNoteId>>>
    export type DeleteVisitsVisitIdNotesNoteIdMutationBody = DeleteVisitMedicalRecordsAdminApiInContract
    export type DeleteVisitsVisitIdNotesNoteIdMutationError = ErrorDescription | void | ErrorApiOutContract

    /**
 * @summary Deletes a single clinical note on a visit. Requires the `visit.medicalrecords.delete` permission. A reason is required and is recorded as a visit remark.
 */
export const useDeleteVisitsVisitIdNotesNoteId = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVisitsVisitIdNotesNoteId>>, TError,{visitId: string;noteId: string;data: DeleteVisitMedicalRecordsAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteVisitsVisitIdNotesNoteId>>,
        TError,
        {visitId: string;noteId: string;data: DeleteVisitMedicalRecordsAdminApiInContract},
        TContext
      > => {

      const mutationOptions = getDeleteVisitsVisitIdNotesNoteIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * # Possible Errors
| HTTP status | ErrorCode                  | Description                                                    |
|-------------|----------------------------|----------------------------------------------------------------|
| 400         | ReasonNotValid             | A reason is required.                                          |
| 403         | Permission                 | The admin lacks the visit.medicalrecords.delete permission.   |
| 404         | VisitNotFound              | Visit with the sent identifier is not found.                  |
| 404         | PatientInstructionNotFound | The visit has no patient instruction with the sent identifier. |
 * @summary Deletes a single patient instruction on a visit. Requires the `visit.medicalrecords.delete` permission. A reason is required and is recorded as a visit remark.
 */
export const deleteVisitsVisitIdPatientInstructionsPatientInstructionId = (
    visitId: string,
    patientInstructionId: string,
    deleteVisitMedicalRecordsAdminApiInContract: DeleteVisitMedicalRecordsAdminApiInContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<unknown>(
      {url: `https://admins-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/patient-instructions/${encodeURIComponent(String(patientInstructionId))}`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteVisitMedicalRecordsAdminApiInContract
    },
      options);
    }
  


export const getDeleteVisitsVisitIdPatientInstructionsPatientInstructionIdMutationOptions = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVisitsVisitIdPatientInstructionsPatientInstructionId>>, TError,{visitId: string;patientInstructionId: string;data: DeleteVisitMedicalRecordsAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteVisitsVisitIdPatientInstructionsPatientInstructionId>>, TError,{visitId: string;patientInstructionId: string;data: DeleteVisitMedicalRecordsAdminApiInContract}, TContext> => {

const mutationKey = ['deleteVisitsVisitIdPatientInstructionsPatientInstructionId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVisitsVisitIdPatientInstructionsPatientInstructionId>>, {visitId: string;patientInstructionId: string;data: DeleteVisitMedicalRecordsAdminApiInContract}> = (props) => {
          const {visitId,patientInstructionId,data} = props ?? {};

          return  deleteVisitsVisitIdPatientInstructionsPatientInstructionId(visitId,patientInstructionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteVisitsVisitIdPatientInstructionsPatientInstructionIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVisitsVisitIdPatientInstructionsPatientInstructionId>>>
    export type DeleteVisitsVisitIdPatientInstructionsPatientInstructionIdMutationBody = DeleteVisitMedicalRecordsAdminApiInContract
    export type DeleteVisitsVisitIdPatientInstructionsPatientInstructionIdMutationError = ErrorDescription | void | ErrorApiOutContract

    /**
 * @summary Deletes a single patient instruction on a visit. Requires the `visit.medicalrecords.delete` permission. A reason is required and is recorded as a visit remark.
 */
export const useDeleteVisitsVisitIdPatientInstructionsPatientInstructionId = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVisitsVisitIdPatientInstructionsPatientInstructionId>>, TError,{visitId: string;patientInstructionId: string;data: DeleteVisitMedicalRecordsAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteVisitsVisitIdPatientInstructionsPatientInstructionId>>,
        TError,
        {visitId: string;patientInstructionId: string;data: DeleteVisitMedicalRecordsAdminApiInContract},
        TContext
      > => {

      const mutationOptions = getDeleteVisitsVisitIdPatientInstructionsPatientInstructionIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getVisitsVisitIdRemarks = (
    visitId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/remarks`, method: 'GET', signal
    },
      options);
    }
  



export const getGetVisitsVisitIdRemarksInfiniteQueryKey = (visitId?: string,) => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/visits/${visitId}/remarks`
    ] as const;
    }

export const getGetVisitsVisitIdRemarksQueryKey = (visitId?: string,) => {
    return [
    `https://admins-api.api.quick.md/api/v1/visits/${visitId}/remarks`
    ] as const;
    }

    
export const getGetVisitsVisitIdRemarksInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdRemarksInfiniteQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>> = ({ signal }) => getVisitsVisitIdRemarks(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(visitId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdRemarksInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>>
export type GetVisitsVisitIdRemarksInfiniteQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdRemarksInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdRemarksInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdRemarksInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVisitsVisitIdRemarksInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdRemarksInfiniteQueryOptions(visitId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetVisitsVisitIdRemarksInfiniteQuery = async <TData = Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsVisitIdRemarksInfiniteQueryOptions(visitId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsVisitIdRemarksQueryOptions = <TData = Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdRemarksQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>> = ({ signal }) => getVisitsVisitIdRemarks(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(visitId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdRemarksQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>>
export type GetVisitsVisitIdRemarksQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdRemarks<TData = Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdRemarks<TData = Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdRemarks<TData = Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVisitsVisitIdRemarks<TData = Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdRemarksQueryOptions(visitId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetVisitsVisitIdRemarksQuery = async <TData = Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsVisitIdRemarksQueryOptions(visitId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsVisitIdRemarksSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdRemarksQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>> = ({ signal }) => getVisitsVisitIdRemarks(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdRemarksSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>>
export type GetVisitsVisitIdRemarksSuspenseQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdRemarksSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdRemarksSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdRemarksSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVisitsVisitIdRemarksSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdRemarksSuspenseQueryOptions(visitId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetVisitsVisitIdRemarksSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdRemarksInfiniteQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>> = ({ signal }) => getVisitsVisitIdRemarks(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdRemarksSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>>
export type GetVisitsVisitIdRemarksSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdRemarksSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdRemarksSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdRemarksSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVisitsVisitIdRemarksSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdRemarksSuspenseInfiniteQueryOptions(visitId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postVisitsVisitIdRemarks = (
    visitId: string,
    messageApiContract: MessageApiContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/remarks`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: messageApiContract, signal
    },
      options);
    }
  


export const getPostVisitsVisitIdRemarksMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdRemarks>>, TError,{visitId: string;data: MessageApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdRemarks>>, TError,{visitId: string;data: MessageApiContract}, TContext> => {

const mutationKey = ['postVisitsVisitIdRemarks'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postVisitsVisitIdRemarks>>, {visitId: string;data: MessageApiContract}> = (props) => {
          const {visitId,data} = props ?? {};

          return  postVisitsVisitIdRemarks(visitId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostVisitsVisitIdRemarksMutationResult = NonNullable<Awaited<ReturnType<typeof postVisitsVisitIdRemarks>>>
    export type PostVisitsVisitIdRemarksMutationBody = MessageApiContract
    export type PostVisitsVisitIdRemarksMutationError = void | ErrorApiOutContract

    export const usePostVisitsVisitIdRemarks = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdRemarks>>, TError,{visitId: string;data: MessageApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postVisitsVisitIdRemarks>>,
        TError,
        {visitId: string;data: MessageApiContract},
        TContext
      > => {

      const mutationOptions = getPostVisitsVisitIdRemarksMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const putVisitsVisitIdRemarksRemarkId = (
    visitId: string,
    remarkId: string,
    messageApiContract: MessageApiContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/remarks/${encodeURIComponent(String(remarkId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: messageApiContract
    },
      options);
    }
  


export const getPutVisitsVisitIdRemarksRemarkIdMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdRemarksRemarkId>>, TError,{visitId: string;remarkId: string;data: MessageApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdRemarksRemarkId>>, TError,{visitId: string;remarkId: string;data: MessageApiContract}, TContext> => {

const mutationKey = ['putVisitsVisitIdRemarksRemarkId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putVisitsVisitIdRemarksRemarkId>>, {visitId: string;remarkId: string;data: MessageApiContract}> = (props) => {
          const {visitId,remarkId,data} = props ?? {};

          return  putVisitsVisitIdRemarksRemarkId(visitId,remarkId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutVisitsVisitIdRemarksRemarkIdMutationResult = NonNullable<Awaited<ReturnType<typeof putVisitsVisitIdRemarksRemarkId>>>
    export type PutVisitsVisitIdRemarksRemarkIdMutationBody = MessageApiContract
    export type PutVisitsVisitIdRemarksRemarkIdMutationError = void | ErrorApiOutContract

    export const usePutVisitsVisitIdRemarksRemarkId = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdRemarksRemarkId>>, TError,{visitId: string;remarkId: string;data: MessageApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putVisitsVisitIdRemarksRemarkId>>,
        TError,
        {visitId: string;remarkId: string;data: MessageApiContract},
        TContext
      > => {

      const mutationOptions = getPutVisitsVisitIdRemarksRemarkIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const deleteVisitsVisitIdRemarksRemarkId = (
    visitId: string,
    remarkId: string,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/remarks/${encodeURIComponent(String(remarkId))}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteVisitsVisitIdRemarksRemarkIdMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVisitsVisitIdRemarksRemarkId>>, TError,{visitId: string;remarkId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteVisitsVisitIdRemarksRemarkId>>, TError,{visitId: string;remarkId: string}, TContext> => {

const mutationKey = ['deleteVisitsVisitIdRemarksRemarkId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVisitsVisitIdRemarksRemarkId>>, {visitId: string;remarkId: string}> = (props) => {
          const {visitId,remarkId} = props ?? {};

          return  deleteVisitsVisitIdRemarksRemarkId(visitId,remarkId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteVisitsVisitIdRemarksRemarkIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVisitsVisitIdRemarksRemarkId>>>
    
    export type DeleteVisitsVisitIdRemarksRemarkIdMutationError = void | ErrorApiOutContract

    export const useDeleteVisitsVisitIdRemarksRemarkId = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVisitsVisitIdRemarksRemarkId>>, TError,{visitId: string;remarkId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteVisitsVisitIdRemarksRemarkId>>,
        TError,
        {visitId: string;remarkId: string},
        TContext
      > => {

      const mutationOptions = getDeleteVisitsVisitIdRemarksRemarkIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    